$(document).ready(function(){
     if (window.location.href.includes('products')) {
      if (window.location.href.indexOf('#bulk_quote') > -1) {
      $('.bulk_quote_success').fadeIn();
      setTimeout(function(){
        $('.bulk_quote_success').fadeOut(1000);
      },3000)  
    } 
    }
  // product bulk form code start
  $('.prd_get_bulk_right').click(function(){
    $('.bulk_quote_main').addClass('open');
    $('body').addClass('body_scroll_stop');
    setTimeout(function(){
      $('.bulk_quote_inner').addClass('show');
    },500);
  });
  $('.bulk_quote_inner .close_form').click(function(){
    $('.bulk_quote_inner').removeClass('show');
    setTimeout(function(){
       $('.bulk_quote_main').removeClass('open');
       $('body').removeClass('body_scroll_stop');
    },500);
  });
  $('.bulk_quote_main, .bulk_quote_main .bulk_quote').click(function(e) {
    // Prevent default action
    e.preventDefault();
    
    // Ensure click is only on the .bulk_quote_main element itself
    if (e.target === this) {
        $('.bulk_quote_inner').removeClass('show');
        setTimeout(function(){
           $('.bulk_quote_main').removeClass('open');
           $('body').removeClass('body_scroll_stop');
        },500);
    }
});
  
   
  
   function validateField(fieldId, errorId, message) {
        let value = $(fieldId).val().trim();
        if (value === '') {
            $(errorId).text(message).show();
            return false;
        } else {
            $(errorId).hide();
            return true;
        }
    }

    function validateEmail() {
        let email = $('#email').val().trim();
        let emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        
        if (email === '') {
            $('#email-error').text("Email is required.").show();
            $('#email-invalid').hide();
            return false;
        } else if (!emailPattern.test(email)) {
            $('#email-invalid').text("Email is not valid.").show();
            $('#email-error').hide();
            return false;
        } else {
            $('#email-error').hide();
            $('#email-invalid').hide();
            return true;
        }
    }

    function validateState() {
        const state = $('#enter_your_state').val();
        if (!state || state === 'SelectState') {
          $('#state-error__page').text('State is required.').show();
          return false;
        } else {
          $('#state-error__page').hide();
          return true;
        }
      }
    function checkFormValidity() {
        // Validate all fields and return true if all are valid
        let isValid = validateField('#product-quantity', '#product-quantity-error', 'Product quantity is required.') &&
                      validateField('#first-name', '#name-error', 'Name is required.') &&
                      validateField('#phone', '#phone-error', 'Phone number is required.') &&
                      validateEmail() && validateState();
                      // validateField('#enter_your_state', '#state-error', 'State is required.') &&
                      // validateField('#enter_your_city', '#city-error', 'City is required.');


        return isValid;
    }

      $('#bulk_quote_submit').click(function() {
          // Check if all fields are valid
          if (checkFormValidity()) {
              // If valid, trigger form submission
              $('#bulk_quote').submit();
          }
      });
  
      // Validate fields on input
      $('#first-name').on('input', function() {
          validateField('#first-name', '#name-error', 'Name is required.');
      });
  
      $('#phone').on('input', function() {
          let phone = $('#phone').val();
  
          // Allow only numbers and limit to 10 digits
          phone = phone.replace(/[^0-9]/g, ''); // Remove non-numeric characters
          if (phone.length > 10) {
              phone = phone.substring(0, 10); // Trim to 10 digits
          }
  
          $('#phone').val(phone); // Set the cleaned value
          validateField('#phone', '#phone-error', 'Phone number is required.');
      });
  
      $('#email').on('input', function() {
          validateEmail();
      });
  
      $('#product-quantity').on('input', function() {
    let quantity = $(this).val();

    // Allow only digits (no decimal points) and ensure no negative numbers
    quantity = quantity.replace(/[^0-9]/g, ''); 

    $(this).val(quantity); // Set the cleaned value
    validateField('#product-quantity', '#product-quantity-error', 'Product quantity is required.');
});

  $('#enter_your_state').on('input', function() {
        validateField('#enter_your_state', '#state-error', 'State is required.');
    });

    $('#enter_your_city').on('input', function() {
        validateField('#enter_your_city', '#city-error', 'City is required.');
    });

  // product bulk form code end
   // $('.checkout_login').click(function(e){
   //    alert("clicked");
   //    e.preventDefault();
   //    $('.sotp-popup-wrapper').addClass('active');
   //    $('.sotp-popup-content').addClass('popup-transition');
   //    $('html').addClass('overflow-hidden');
   //    $('body').addClass('overflow-hidden');
   //  });
   $(document).on('click', '.checkout_login', function(e){
     e.preventDefault();
     $('.atc-banner--close').trigger('click');
      $('.sotp-popup-wrapper').addClass('active');
      $('.sotp-popup-content').addClass('popup-transition');
      $('html').addClass('overflow-hidden');
      $('body').addClass('overflow-hidden');
   })
  $('.site-mobile-nav a.site-header_account-link-anchor').click(function(){
      $('.mobile-nav-overlay').trigger('click');
});

let windowWidthHome = $(window).width();
    if (windowWidthHome < 720){
      setTimeout(function(){
        let firstimageheight = $('section.slideshow .flickity-viewport .slideshow-slide:first-child').height();
        let height = `${firstimageheight}px`;
        $("section.slideshow .flickity-viewport").css("height", height);
        // alert(height);
      },1000);
    }else {
       setTimeout(function(){
        let firstimageheight = $('section.slideshow .flickity-viewport .slideshow-slide:first-child').height();
        let height = `${firstimageheight}px`;
         $("section.slideshow .flickity-viewport").css("height", height);
        // alert(height);
      },1000);
    }

  //   $(document).on('click', '.site-header__account-link--logout', function() {
  //   //   alert("Logout clicked");
  //     $.ajax({
  //     type: 'POST',
  //     url: '/cart/clear',
  //     success: function () {
  //       // window.location.assign("/account/logout");
  //       window.location.href = "/account/logout";
  //     },
  //     error: function (xhr, status, error) {
  //       // console.error('Error:', error);
  //     }
  //   });   
       
  //    // window.location.assign("/cart/clear");  
  // });

$('.site-header-actions .site-header__account-icon.login').click(function(){
  $(this).next().slideToggle();
})
  
});

